import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import ModalContainer from "../../modal/ModalContainer";

import { DialogContent,Divider, DialogActions,Typography, Button, Grid, TextField,Switch} from "@material-ui/core";
import moment from "moment";

@inject("venueActStore", "profileStore", "templateStore")
@observer
class InvoiceVenueActModal extends Component {
    sigCanvas = {};
    state = {
        isLoading: false,
        isSwitchOn: false
    }


    componentDidUpdate(prevProps) {
        if (prevProps.open !== this.props.open) {
            var data = this.props.data
            this.setState({
                isSwitchOn: data?.invoiceType === 1
            })
        }
    }

    handleSwitchOn = e => this.setState({isSwitchOn: !this.state.isSwitchOn})   

    onClose = () => {
        // this.props.agentVenueContactStore.reset()
        this.props.onClose()
    }

    handleSubmit = () => {
        this.props.templateStore.showLoadingScreen();
       this.props.venueActStore.updateVenueAct(this.props.data?.id, this.state.isSwitchOn).then(() => {
             this.props.templateStore.hideLoadingScreen();
                this.props.templateStore.openSnackbar(`${this.props.data?.venue?.profileName} invoice type have been updated`);
            
                this.onClose()
       })
    };


    
    render() {
        const {isSwitchOn} = this.state
        const { open, onClose, data } = this.props;
        return (
            <ModalContainer open={open} onClose={onClose} onEntered={this.onEntered} fullScreen={false} maxWidth="sm" title={`${data?.venue ? data.venue.profileName : "Venue"} Invoice Type`} coloredDialogTitle={true}>
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={12} md={12}>
                            <Grid item xs={12} md={12}>
                                <Switch checked={isSwitchOn} onChange={this.handleSwitchOn} value="hideToolbar" /> Act Player Invoices paid by Venue
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose}>Close</Button>
                    <Button id="btn-confirm-processbooking" onClick={this.handleSubmit} color="primary" className="process-booking">
                        Save
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default InvoiceVenueActModal;
